const processItemsForCsv = (rowArray: string[]): string[] => {
   const quotedRowArray: string[] = [];
   rowArray.forEach(columnItem => {
      columnItem = columnItem.replace(/"/g, '""');
      quotedRowArray.push(`"${columnItem}"`);
   });
   return quotedRowArray;
};

const createCsv = (csvRowData: string[][]): string => {
   const bomChar = '\ufeff';
   let csvContent = bomChar;
   csvRowData.forEach(rowArray => {
      const processedRowArray = processItemsForCsv(rowArray).join(',');
      csvContent += `${processedRowArray}\r\n`;
   });
   return csvContent;
};

const downloadReviewCsv = (reviewTitle: string, csvRowData: string[][]): Promise<void> => {
   const csvFileName = `${reviewTitle}-comments.csv`;
   const csvContent = createCsv(csvRowData);
   const blob = new Blob([csvContent], {type: 'text/csv'});

   // @ts-ignore
   if (navigator.msSaveOrOpenBlob) {
      // old IE
      // @ts-ignore
      navigator.msSaveOrOpenBlob(blob, csvFileName);
   } else {
      const anchor = document.createElement('a');
      if (typeof anchor.download !== 'undefined') {
         // modern HTML5 feature
         document.body.appendChild(anchor);
         anchor.setAttribute('href', URL.createObjectURL(blob));
         anchor.setAttribute('download', csvFileName);
         anchor.click();
      } else {
         // iOS safari and other browsers that don't have anchor.download
         window.location.href = 'data:application/octet-stream,' + encodeURIComponent(csvContent);
      }
   }

   return Promise.resolve();
};

export {downloadReviewCsv};
